export const BUZZTYPE = {
  1: 'pop',
  2: 'pop',
  3: 'brand',
  4: 'partner',
  5: 'yuer',
  6: 'czj',
  7: 'partner',
  11: 'partner'
}

export const BUZZTYPE_LEYOU = {
  1: 'pop',
  2: 'global', // 全球购
  3: 'partner',   // 自营 品牌商
  4: 'partner', // 自营 供应商
  5: 'yuer',
  6: 'czj',
  7: 'partner',
  11: 'partner'
}

export const SUPPORTBUZZTYPE = [1,2,3,4,5,6,7,11]

export const REG_PHONE = /^1[3456789]\d{9}$/

export const MSGBOX_APP_CODE = 'hzwygj'
